export default function toPixelString(value: number): string {
    return value === Number.NaN ? '' : value === 0 ? '0' : value.toString() + 'px';
}
